import React, {useEffect, useState} from "react";
import {LoggedInView} from "../common/LoggedInView";
import {useAppDispatch} from "../../utils/Hooks";
import {getSMSSenders} from "../../store/reducers/SMSSendersSlice";
import {SMSSendersTable} from "./components/SMSSendersTable";

interface SMSSendersScreenProps {
}

export const SMSSendersScreen: React.FC<SMSSendersScreenProps> = () => {

    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(getSMSSenders());
    }, []);

    return (
        <LoggedInView fullWidth={false}>
            <h1>SMSi saatjad</h1>
            <SMSSendersTable />
        </LoggedInView>
    )

}